
const getDefaultState = () => ({

  claimPayees: {},
  selectedClaimPayeeData:{} 

})


export const ClaimRemittanceDSModule = {

  namespaced : true,

  state: getDefaultState() ,

  getters: {

  },

  mutations: {
    resetState(state){
      state = { ...getDefaultState() }
    },
    setClaimPayees(state, payload){
      const clonePayees = Object.assign({}, state.claimPayees)
      state.claimPayees = {}
      state.claimPayees = { ...clonePayees,  [payload.PartyID]: payload }

      console.log('state :>> ', state);
    },
    setSelectedClaimPayeeData(state, payload){
      state.selectedClaimPayeeData = {}
      state.selectedClaimPayeeData = {...payload}
      console.log('state setSelectedClaimPayeeData :>> ', state);
      
    }
  },

  actions: {

    
  }




}